export default {
	title: "Skontaktuj się z nami",
	descirption:
		"Skontaktuj się z nami, aby uzyskać więcej informacji na temat naszych usług. Chętnie pomożemy.",
	subtitle: "Czy jesteś zainteresowany naszymi usługami? Skontaktuj się z nami.",
	phone: "Możesz do nas zadzwonić pod numer",
	email: "Lub wysłać e-mail na adres",
	address: {
		title: "Znajdź nas",
		fenex: "FENEX",
		kvk: "KVK",
		vat: "BTW",
	},
	team: {
		title: "Poznaj nasz zespół",
	},
	form: {
		title: "Wyślij nam wiadomość",
		firstName: "Imię",
		firstNameHint: "Wpisz swoje imię",
		lastName: "Nazwisko",
		lastNameHint: "Wpisz swoje nazwisko",
		email: "Email",
		emailHint: "Wpisz swój email, abyśmy mogli się z tobą skontaktować",
		phone: "Telefon",
		phoneHint: "Wpisz swój numer telefonu, jeśli chcesz, abyśmy do ciebie zadzwonili",
		message: "Wiadomość",
		messageHint: "Wpisz swoją wiadomość",
		submit: "Wyślij wiadomość",
		successTitle: "Dziękujemy!",
		successMessage: "Twoja wiadomość została pomyślnie wysłana",
	},
};
